import { BaseConfig } from '../ServiceConfig';

export interface OMConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.OmServiceConfigData';
  url: string;
  channel: string;
  channelId: string;
  channelType: string;
}

export const OMConfigurationFields: (keyof OMConfiguration)[] = [
  'url',
  'channel',
  'channelId',
  'channelType',
];

export const BlankOMConfiguration: OMConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.OmServiceConfigData',
} as OMConfiguration;
